import React, {useCallback, useEffect, useState} from 'react';
import { IoCloseOutline } from "react-icons/io5";
import { MdOutlineArrowBackIosNew, MdOutlineArrowForwardIos } from "react-icons/md";

const Gallery = ({
    images,
    gallery,
    setGallery
}) => {
    const lastImageIndex = images.length - 1;
    const [currentIndex, setCurrentIndex] = useState(0);

    const moveForward = (useCallback((event) => {
        if(event) {
            event.stopPropagation()
        }
        if(currentIndex === lastImageIndex) {
            setCurrentIndex(0);
        } else {
            setCurrentIndex(currentIndex + 1);
        }
    }, [currentIndex, lastImageIndex]))

    const moveBack = (useCallback((event) => {
        if(event) {
            event.stopPropagation()
        }
        if(currentIndex === 0) {
            setCurrentIndex(lastImageIndex);
        } else {
            setCurrentIndex(currentIndex - 1);
        }
    }, [currentIndex, lastImageIndex]))

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.keyCode === 39) {
                moveForward(event);
            }
            if (event.keyCode === 37) {
                moveBack(event);
            }
            if (event.keyCode === 27) {
                setGallery(false);
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [moveBack, moveForward, setGallery]);

    useEffect(() => {
        setCurrentIndex(0);
    }, [images]);

    useEffect(() => {
        if(gallery) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
    }, [gallery]);

    return (
        <>
            { gallery &&
                <div className='gallery-container' onClick={() => setGallery(false)}>
                    <span className='close-button flex jc-c ai-c' onClick={() => setGallery(false)}>
                        <IoCloseOutline className='iconz'/>
                    </span>
                    <span className='forwards flex jc-c ai-c' onClick={moveForward}>
                        <MdOutlineArrowForwardIos className='iconz' />
                    </span>
                    <span className='backwards flex jc-c ai-c' onClick={moveBack}>
                        <MdOutlineArrowBackIosNew className='iconz' />
                    </span>
                    <div className='image-preview flex col ai-c'>
                        <div className='image-containere flex jc-c ai-c'>
                            <img src={images[currentIndex]} alt='' />
                        </div>
                        <span className='navigation'> {currentIndex + 1} / {lastImageIndex + 1} </span>
                    </div>
                </div>
            }
        </>
    );
};

export default Gallery;